export const NOTIFICATION_ADD = 'app/notifications/NOTIFICATION_ADD';
export const NOTIFICATION_CLEAR = 'app/notifications/NOTIFICATION_CLEAR';
export const NOTIFICATION_CLEAR_ALL =
  'app/notifications/NOTIFICATION_CLEAR_ALL';
export const NOTIFICATION_SET_INTRO =
  'app/notifications/NOTIFICATION_SET_INTRO';
